var exports = {
  "U": "RoleIcon.module__roleIcon___OVVtMF",
  "Z": "RoleIcon.module__roleIconImage___OVVtMF",
};

module.exports = exports;
